type GetCommentsParams = {
  plantId: string
  commentsCategory: string
}

type CommentInstanceParams = GetCommentsParams & {
  commentCategoryInstanceId: string
}

type CommentByIdParams = CommentInstanceParams & {
  commentId: string
}

export const getCommentsPath = ({plantId, commentsCategory}: GetCommentsParams): string =>
  `/comments/${plantId}/${commentsCategory}`

export const addCommentPath = ({
  plantId,
  commentsCategory,
  commentCategoryInstanceId
}: CommentInstanceParams): string =>
  `/comments/${plantId}/${commentsCategory}/${commentCategoryInstanceId}`

export const editCommentPath = ({
  plantId,
  commentsCategory,
  commentCategoryInstanceId,
  commentId
}: CommentByIdParams): string =>
  `/comments/${plantId}/${commentsCategory}/${commentCategoryInstanceId}/${commentId}`

export const deleteCommentPath = ({
  plantId,
  commentsCategory,
  commentCategoryInstanceId,
  commentId
}: CommentByIdParams): string =>
  `/comments/${plantId}/${commentsCategory}/${commentCategoryInstanceId}/${commentId}`
